import React from 'react';

import withContextConsumer from './withContextConsumer';

import { IExperiments } from '@wix/podcasts-common/dist/experiments';

const { Provider: ExperimentsProvider, Consumer: ExperimentsConsumer } =
  React.createContext<IExperiments>(null);

const withExperiments = withContextConsumer<IExperiments>(
  ExperimentsConsumer,
  (experiments) => ({
    experiments,
  }),
);

interface IWithExperimentsProps {
  experiments: IExperiments;
}

export {
  ExperimentsProvider,
  ExperimentsConsumer,
  withExperiments,
  IWithExperimentsProps,
};
